import { render } from "./SupportImam.vue?vue&type=template&id=9ff63bf0&scoped=true"
import script from "./SupportImam.vue?vue&type=script&lang=js"
export * from "./SupportImam.vue?vue&type=script&lang=js"

import "./SupportImam.vue?vue&type=style&index=0&id=9ff63bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff63bf0"]])

export default __exports__